import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errorMessage = (err, fallback = "Something went wrong. Please call (931) 473-3465.") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return `${d[0].loc?.slice(-1)[0] ?? "Field"}: ${d[0].msg}`;
  return fallback;
};

export const submitLead = (payload) => axios.post(`${API}/leads`, payload);
export const submitService = (formData) => axios.post(`${API}/service-requests`, formData);
